<template>
	<svg
		class="bidirectional-label-bg"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 640 94"
		preserveAspectRatio="none"
	>
		<defs>
			<pattern
				id="silk-flag-pattern"
				patternUnits="userSpaceOnUse"
				width="1080"
				height="330"
			>
				<image :href="pathTextures + '/silk-flag-texture-bg.avif'" />
			</pattern>
		</defs>
		<g id="left">
			<polygon
				class="frame-light-part"
				points="15.56 42.76 14.15 44.18 12.73 45.59 14.14 44.17 15.56 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="15.56 42.76 14.15 44.18 12.73 45.59 14.14 44.17 15.56 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="15.56 42.76 14.15 44.18 12.73 45.59 14.14 44.17 15.56 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="15.56 42.76 14.15 44.18 12.73 45.59 14.14 44.17 15.56 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="15.56 42.76 14.15 44.18 12.73 45.59 14.14 44.17 15.56 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="15.56 42.76 14.15 44.18 12.73 45.59 14.14 44.17 15.56 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="11.32 38.52 9.91 39.94 8.49 41.35 9.9 39.93 11.32 38.52"
			/>
			<polygon
				class="frame-light-part"
				points="15.56 42.76 14.15 44.18 12.73 45.59 14.14 44.17 15.56 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="15.56 42.76 14.15 44.18 12.73 45.59 14.14 44.17 15.56 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="15.56 42.76 14.15 44.18 12.73 45.59 14.14 44.17 15.56 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="15.56 42.76 14.15 44.18 12.73 45.59 14.14 44.17 15.56 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="15.56 42.76 14.15 44.18 12.73 45.59 14.14 44.17 15.56 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="15.56 42.76 14.15 44.18 12.73 45.59 14.14 44.17 15.56 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="63.63 6 94 6 94 8 61.63 8 63.63 6"
			/>
			<polygon
				class="frame-dark-part"
				points="61.62 86 94 86 94 88 63.62 88 61.62 86"
			/>
			<polygon
				class="frame-dark-part"
				points="61.63 8 94 8 94 10 59.63 10 22.63 47.01 21.22 48.42 19.8 49.83 18.39 51.25 16.98 52.66 16.97 52.66 15.56 54.07 14.15 55.49 12.73 56.9 47.83 92 94 92 94 94 47 94 11.32 58.32 9.9 56.9 11.32 55.49 12.73 54.07 14.14 52.66 16.97 49.83 18.39 48.42 19.8 47 21.21 45.59 56.8 10 64.8 2 94 2 94 4 65.63 4 61.63 8"
			/>
			<polygon
				class="frame-dark-part"
				points="61.97 2 59.97 4 57.14 4 53.14 8 55.97 8 53.97 10 51.14 10 16.97 44.17 18.39 45.59 16.98 47.01 15.56 45.59 14.14 47 12.73 48.41 14.14 49.83 12.73 51.25 11.31 49.83 9.9 51.24 8.49 52.66 9.9 54.07 8.49 55.49 7.07 54.07 5.66 52.66 7.07 51.24 8.49 49.83 12.73 45.59 14.15 44.18 15.56 42.76 56.32 2 61.97 2"
			/>
			<path
				class="frame-light-part"
				d="M47,0L9.9,37.1l-1.41,1.42-1.42,1.41-1.41,1.41-1.42,1.42-1.41,1.41-1.41,1.42-1.42,1.41,1.42,1.42,1.41-1.42,1.42-1.41,1.41-1.41h0s1.41-1.42,1.41-1.42l1.42-1.41,1.41-1.42,1.42-1.41,1.41-1.42,29.1-29.1h5.65l-31.93,31.93-1.41-1.41-1.41,1.41,1.41,1.41-1.41,1.42-1.42,1.41-1.41-1.41-1.41,1.41,1.41,1.41-1.42,1.42-1.41,1.41-1.41-1.41-1.41,1.42,1.41,1.41-1.42,1.41,1.42,1.42,1.41-1.42,1.42-1.41,4.24-4.24,1.41-1.42,1.42-1.41L56.32,2h5.65l-4,4h-2.83l-2,2h2.83L19.8,44.17l-1.42-1.41-1.41,1.41,1.42,1.42-1.41,1.42-1.42,1.41-1.42-1.42-1.41,1.41,1.41,1.42-1.41,1.42-1.41,1.41-1.42-1.42-1.41,1.42,1.41,1.41-1.41,1.42,1.41,1.41,1.42-1.41,1.41-1.42,1.41-1.41,2.83-2.83,1.42-1.41,1.41-1.42,1.41-1.41L56.8,10l8-8h29.2V0h-47ZM49.48,6h-5.65l4-4h5.65l-4,4ZM94,84h-34.38L22.63,47.01l-1.41,1.41,41.58,41.58h-5.66l-4-4h2.83l-2-2h-2.83L18.39,51.25l-1.41,1.41,31.34,31.34,6,6h-5.66l-4-4h2.82l-2-2h-2.82l-28.51-28.51-1.42,1.41,35.1,35.1h46.17v-2h-28.38l-4-4h32.38v-2Z"
			/>
			<polygon
				class="frame-dark-part"
				points="11.32 38.52 9.91 39.94 9.9 39.93 11.32 38.52"
			/>
			<polygon
				class="frame-dark-part"
				points="15.56 42.76 14.15 44.18 14.14 44.17 15.56 42.76"
			/>
			<polygon
				class="frame-dark-part"
				points="62.8 90 59.97 90 57.97 88 55.14 88 53.14 86 55.97 86 53.97 84 19.8 49.83 21.22 48.42 62.8 90"
			/>
			<polygon
				class="frame-dark-part"
				points="54.32 90 51.48 90 49.48 88 46.66 88 44.66 86 47.48 86 45.48 84 15.56 54.07 16.97 52.66 16.98 52.66 48.32 84 54.32 90"
			/>
			<polygon
				class="frame-dark-part"
				points="47.48 8 45.48 10 42.66 10 14.14 38.52 12.73 39.93 14.14 41.34 12.73 42.76 11.32 41.35 9.9 42.76 8.49 44.17 9.9 45.58 8.48 47 7.07 45.59 5.66 47 4.25 48.42 5.66 49.83 4.24 51.24 1.42 48.42 2.83 47 4.25 45.59 5.66 44.18 5.66 44.17 7.07 42.76 8.49 41.35 9.91 39.94 11.32 38.52 12.73 37.1 41.83 8 47.48 8"
			/>
			<polygon
				class="frame-dark-part"
				points="11.32 38.52 9.91 39.94 8.49 41.35 9.9 39.93 11.32 38.52"
			/>
			<polygon
				class="frame-dark-part"
				points="53.48 2 51.48 4 48.66 4 46.66 6 43.83 6 47.83 2 53.48 2"
			/>
			<polygon
				class="frame-dark-part"
				points="15.56 42.76 14.15 44.18 12.73 45.59 14.14 44.17 15.56 42.76"
			/>
		</g>
		<g id="middle">
			<rect
				class="frame-light-part"
				x="94"
				y="6"
				width="452"
				height="2"
			/>
			<rect
				class="frame-dark-part"
				x="94"
				y="86"
				width="452"
				height="2"
			/>
			<rect class="frame-dark-part" x="94" y="2" width="452" height="2" />
			<rect class="frame-dark-part" x="94" y="8" width="452" height="2" />
			<rect
				class="frame-dark-part"
				x="94"
				y="92"
				width="452"
				height="2"
			/>
			<path
				class="frame-light-part"
				d="M94,84v2h452v-2H94ZM94,90v2h452v-2H94ZM94,0v2h452V0H94Z"
			/>
		</g>
		<g id="right">
			<polygon
				class="frame-light-part"
				points="624.44 42.76 625.85 44.18 627.27 45.59 625.86 44.17 624.44 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="624.44 42.76 625.85 44.18 627.27 45.59 625.86 44.17 624.44 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="624.44 42.76 625.85 44.18 627.27 45.59 625.86 44.17 624.44 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="624.44 42.76 625.85 44.18 627.27 45.59 625.86 44.17 624.44 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="624.44 42.76 625.85 44.18 627.27 45.59 625.86 44.17 624.44 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="624.44 42.76 625.85 44.18 627.27 45.59 625.86 44.17 624.44 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="628.68 38.52 630.09 39.94 631.51 41.35 630.1 39.93 628.68 38.52"
			/>
			<polygon
				class="frame-light-part"
				points="624.44 42.76 625.85 44.18 627.27 45.59 625.86 44.17 624.44 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="624.44 42.76 625.85 44.18 627.27 45.59 625.86 44.17 624.44 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="624.44 42.76 625.85 44.18 627.27 45.59 625.86 44.17 624.44 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="624.44 42.76 625.85 44.18 627.27 45.59 625.86 44.17 624.44 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="624.44 42.76 625.85 44.18 627.27 45.59 625.86 44.17 624.44 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="624.44 42.76 625.85 44.18 627.27 45.59 625.86 44.17 624.44 42.76"
			/>
			<polygon
				class="frame-light-part"
				points="576.37 6 546 6 546 8 578.37 8 576.37 6"
			/>
			<polygon
				class="frame-dark-part"
				points="578.38 86 546 86 546 88 576.38 88 578.38 86"
			/>
			<polygon
				class="frame-dark-part"
				points="630.1 56.9 628.68 58.32 593 94 546 94 546 92 592.17 92 627.27 56.9 625.85 55.49 624.44 54.07 623.03 52.66 623.02 52.66 621.61 51.25 620.2 49.83 618.78 48.42 617.37 47.01 580.37 10 546 10 546 8 578.37 8 574.37 4 546 4 546 2 575.2 2 583.2 10 618.79 45.59 620.2 47 621.61 48.42 623.03 49.83 625.86 52.66 627.27 54.07 628.68 55.49 630.1 56.9"
			/>
			<polygon
				class="frame-dark-part"
				points="578.03 2 580.03 4 582.86 4 586.86 8 584.03 8 586.03 10 588.86 10 623.03 44.17 621.61 45.59 623.02 47.01 624.44 45.59 625.86 47 627.27 48.41 625.86 49.83 627.27 51.25 628.69 49.83 630.1 51.24 631.51 52.66 630.1 54.07 631.51 55.49 632.93 54.07 634.34 52.66 632.93 51.24 631.51 49.83 627.27 45.59 625.85 44.18 624.44 42.76 583.68 2 578.03 2"
			/>
			<path
				class="frame-light-part"
				d="M638.58,45.59l-1.41-1.42-1.41-1.41-1.42-1.42-1.41-1.41-1.42-1.41-1.41-1.42L593,0h-47v2h29.2l8,8,35.59,35.59,1.41,1.41,1.41,1.42,1.42,1.41,2.83,2.83,1.41,1.41,1.41,1.42,1.42,1.41,1.41-1.41-1.41-1.42,1.41-1.41-1.41-1.42-1.42,1.42-1.41-1.41-1.41-1.42,1.41-1.42-1.41-1.41-1.42,1.42-1.42-1.41-1.41-1.42,1.42-1.42-1.41-1.41-1.42,1.41-36.17-36.17h2.83l-2-2h-2.83l-4-4h5.65l40.76,40.76,1.42,1.41,1.41,1.42,4.24,4.24,1.42,1.41,1.41,1.42,1.42-1.42-1.42-1.41,1.41-1.41-1.41-1.42-1.41,1.41-1.41-1.41-1.42-1.42,1.41-1.41-1.41-1.41-1.41,1.41-1.42-1.41-1.41-1.42,1.41-1.41-1.41-1.41-1.41,1.41-31.93-31.93h5.65l29.1,29.1,1.41,1.42,1.42,1.41,1.41,1.42,1.42,1.41,1.41,1.41h0s1.41,1.42,1.41,1.42l1.42,1.41,1.41,1.42,1.42-1.42-1.42-1.41ZM590.52,6l-4-4h5.65l4,4h-5.65ZM625.85,55.49l-28.51,28.51h-2.82l-2,2h2.82l-4,4h-5.66l6-6,31.34-31.34-1.41-1.41-32.75,32.75h-2.83l-2,2h2.83l-4,4h-5.66l41.58-41.58-1.41-1.41-36.99,36.99h-34.38v2h32.38l-4,4h-28.38v2h46.17l35.1-35.1-1.42-1.41Z"
			/>
			<polygon
				class="frame-dark-part"
				points="628.68 38.52 630.09 39.94 630.1 39.93 628.68 38.52"
			/>
			<polygon
				class="frame-dark-part"
				points="624.44 42.76 625.85 44.18 625.86 44.17 624.44 42.76"
			/>
			<polygon
				class="frame-dark-part"
				points="577.2 90 580.03 90 582.03 88 584.86 88 586.86 86 584.03 86 586.03 84 620.2 49.83 618.78 48.42 577.2 90"
			/>
			<polygon
				class="frame-dark-part"
				points="585.68 90 588.52 90 590.52 88 593.34 88 595.34 86 592.52 86 594.52 84 624.44 54.07 623.03 52.66 623.02 52.66 591.68 84 585.68 90"
			/>
			<polygon
				class="frame-dark-part"
				points="592.52 8 594.52 10 597.34 10 625.86 38.52 627.27 39.93 625.86 41.34 627.27 42.76 628.68 41.35 630.1 42.76 631.51 44.17 630.1 45.58 631.52 47 632.93 45.59 634.34 47 635.75 48.42 634.34 49.83 635.76 51.24 638.58 48.42 637.17 47 635.75 45.59 634.34 44.18 634.34 44.17 632.93 42.76 631.51 41.35 630.09 39.94 628.68 38.52 627.27 37.1 598.17 8 592.52 8"
			/>
			<polygon
				class="frame-dark-part"
				points="628.68 38.52 630.09 39.94 631.51 41.35 630.1 39.93 628.68 38.52"
			/>
			<polygon
				class="frame-dark-part"
				points="586.52 2 588.52 4 591.34 4 593.34 6 596.17 6 592.17 2 586.52 2"
			/>
			<polygon
				class="frame-dark-part"
				points="624.44 42.76 625.85 44.18 627.27 45.59 625.86 44.17 624.44 42.76"
			/>
		</g>
		<g class="fill-solid">
			<polygon
				class="base-color"
				:class="`color-${theme}`"
				points="617.37 47.01 580.38 84 59.62 84 22.63 47.01 59.63 10 580.37 10 617.37 47.01"
			/>
		</g>
		<g class="fill-texture">
			<polygon
				class="texture-bg-polygon"
				points="617.37 47.01 580.38 84 59.62 84 22.63 47.01 59.63 10 580.37 10 617.37 47.01"
			/>
		</g>
	</svg>
</template>

<script setup lang="ts">
import { LabelThemes } from "@/types/ui";
import { pathTextures } from "@/utils/url";

interface Props {
	theme?: LabelThemes;
}
const { theme = LabelThemes.RED } = defineProps<Props>();
</script>

<style lang="scss" scoped>
.frame-light-part {
	fill: #edd091;
}
.frame-dark-part {
	fill: #63451a;
}
.base-color {
	fill: #770a29;
}
.color-red {
	fill: #770a29;
}
.color-dark-red {
	fill: #4a0008;
}
.color-raspberry {
	fill: hsl(346, 65%, 45%);
}
.color-violet {
	fill: hsl(258, 37%, 49%);
}
.color-green {
	fill: #056253;
}
.color-light-green {
	fill: hsl(157 71% 35% / 1);
}
.color-mid-green {
	fill: hsl(76, 73%, 29%);
}
.color-pine-green {
	fill: #0d5c0d;
}
.color-blue {
	fill: #427a9b;
}
.color-dark-blue {
	fill: #055d7c;
}
.color-grey {
	fill: #606060;
}
.color-bronze {
	fill: #935106;
}
.color-purple {
	fill: #532062;
}
.color-midnight-blue {
	fill: #221456;
}
.color-black {
	// NOTE: this color shade preserves background reflections under blend mode
	fill: #343434;
}
.texture-bg-polygon {
	fill: url(#silk-flag-pattern);
}
.fill-texture {
	mix-blend-mode: color-burn; // NOTE: must be color-burn
}
</style>
